/* src/app/views/template/components/templates/print/print-product-templates/print-product-template-list/print-product-template-list.component.scss */
/*# sourceMappingURL=print-product-template-list.component.css.map */
